import styled from "@emotion/styled";
import { colors } from "src/theme";

export const ValidationErrorStyle = styled.div({
  position: 'absolute',
  color: colors.error1,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '1.14',
  marginBottom: 0,
  paddingTop: '4px',
  transition: 'all 0.4s ease',
  fontFamily: 'Red Hat Display',
});